export var valuesWikiSectionLayout = ["Full", "Halves", "Thirds"];
/*

*/ 
//# sourceMappingURL=WikiSectionLayout.js.map